import { useTranslation } from 'react-i18next';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@codes/ui-kit/components/ui/select';

type SortType = 'newest' | 'oldest';

interface SortSelectProps {
    value: SortType;
    onChange: (value: SortType) => void;
}

export const SortSelect = ({ value, onChange }: SortSelectProps) => {
    const { t } = useTranslation();

    return (
        <Select value={value} onValueChange={t => onChange(t as SortType)}>
            <SelectTrigger className="py-[9px] pr-3 pl-4 border-border rounded-full w-fit">
                <SelectValue placeholder={t('common.all')} />
            </SelectTrigger>
            <SelectContent className="border-none shadow-custom">
                <SelectItem value="newest" className="text-text">
                    {t('common.sort.newest')}
                </SelectItem>
                <SelectItem value="oldest" className="text-text">
                    {t('common.sort.oldest')}
                </SelectItem>
            </SelectContent>
        </Select>
    );
};
